import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { TablepagedComponent, ColumnDef } from '../../../containers/table/tablepaged/tablepaged.component';
import {  FormAddConfig } from "../../../containers/form/formadd/formadd.component";
import {  FormUpdateConfig } from "../../../containers/form/formupdate/formupdate.component";
import { UpdateAddTableComponent, AttributeDefinition } from "../../basic/update-add-table/update-add-table.component";


@Component({
  selector: 'app-right',
  imports: [UpdateAddTableComponent],
  templateUrl: './right.component.html',
  styleUrl: './right.component.scss',
})
export class RightComponent {
title = 'Auth rights';
description = "This are the rights of the App";
path = "/auth/right";
showFormAdd = true
element_name="right";
showUpdateButton = true;
showDeleteButton = true;

config: Array<AttributeDefinition> = [
{ title: 'Id',               store_key: 'Id' },
{ title: 'IdUserCreation',   store_key: 'IdUserCreation', hidden: true},
{ title: 'TimeCreation',     store_key: 'TimeCreation' , hidden: true},
{ title: 'Name',             store_key: 'Name' },
{ title: 'Path',             store_key: 'Path' },
{ title: 'Action',           store_key: 'Action' },
{ title: 'Inverted',         store_key: 'Inverted' }
];

@ViewChild(TablepagedComponent) table!: TablepagedComponent;

}
